import React from 'react'

const ErrorCodes = {
    GENERIC: {
        Type: 'UI',
        Name: 'Generic error',
        Code: '9999',
        Header: 'Oops! Something went wrong',
        Icon: 'fal fa-exclamation-circle',
        message: () => (
            <div
                style={{
                    lineHeight: '1.7rem',
                }}
            >
                You can return to the <a href="/">Home</a> page and retry the same action, or contact our Support Team on 13 13 83 (select option 2)
            </div>
        ),
    },
}

export default ErrorCodes
